import { compose, diff } from "./helper";

let _setGlobalState;

const listeners = compose(onLocaleChange);

export function actionInit({ onGlobalStateChange, setGlobalState: set }) {
  _setGlobalState = set;

  onGlobalStateChange(function (state, prevState) {
    let changeKeys = diff(state, prevState);

    if (!changeKeys.length) return;

    listeners({ changeKeys, state, prevState });
  });
}

export function setGlobalState(...args) {
  return _setGlobalState(...args);
}

// 当语言发生变化
// 当语言发生变化时候，staff作为子应用需要做太多的逻辑了 详见 src/layout/language 组件
// 那就直接刷新页面吧~~
function onLocaleChange({ changeKeys, state, prevState }) {
  if (changeKeys.includes("locale")) {
    window.location.reload();
  }

  return { changeKeys, state, prevState };
}
